import React, { useContext } from 'react';
import { Box, FormControlLabel, Grid, Radio, RadioGroup, Typography, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import {
  Business as BusinessIcon,
  Person as PersonIcon,
  RecentActors as RecentActorsIcon,
} from '@mui/icons-material';
import CardBase from 'components/CardBase';
import IconCircle from 'components/IconCircle';
import { DICTIONARY } from 'shared/constants';
import IconRow from 'components/IconRow';
import IconRowCell from 'components/IconRowCell';

const panelStyle = {
  marginTop: '1rem',
  '& > .MuiPaper-root': {
    marginBottom: '1rem',
  },
};

const getSponsorshipTypeStyles = (theme: Theme) => ({
  card: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '150px',
    textAlign: 'center',
    margin: '0 auto',
  },
  field: {
    display: 'flex',
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  margin: {
    margin: `${theme.spacing(2)} 0`,
  },
  radio: {
    alignItems: 'end',
    alignSelf: 'center',
    display: 'flex',
    flexGrow: 1,
  },
});

const SponsorshipType: React.FC = () => {
  const theme = useTheme();
  const styles = getSponsorshipTypeStyles(theme);
  const { process, setProcess } = useContext(CreateProcessContext);

  const handleTypeSelect = (event: any, value: string) => {
    setProcess((draft) => {
      draft.individualSponsored = value === 'true';
      draft.requestedProcess = null;
      // Clear company data if Individual Sponsorship
      if (value === 'true') {
        draft.companyID = null;
        draft.employmentData = {};
      }
    });
  };

  return (
    <Box sx={panelStyle}>
      <IconRow sx={styles.margin}>
        <IconRowCell type="icon">
          <IconCircle Icon={RecentActorsIcon} />
        </IconRowCell>
        <IconRowCell type="text">
          <Typography variant="h6">{DICTIONARY.SponsorshipType}</Typography>
        </IconRowCell>
      </IconRow>
      <Grid container alignItems="center" sx={styles.margin}>
        <Grid size={12}>
          <RadioGroup
            aria-labelledby="sponsorship-type"
            name="sponsorship-type"
            value={
              process.individualSponsored === null
              || process.individualSponsored === undefined
                ? 'none'
                : process.individualSponsored
            }
            onChange={handleTypeSelect}
          >
            <Grid container spacing={2}>
              <Grid size={6}>
                <CardBase sx={styles.card}>
                  <BusinessIcon />
                  <FormControlLabel
                    sx={styles.field}
                    value={false}
                    control={
                      <Radio color="primary" sx={styles.radio} />
                    }
                    labelPlacement="top"
                    label="COMPANY"
                  />
                </CardBase>
              </Grid>

              <Grid size={6}>
                <CardBase sx={styles.card}>
                  <PersonIcon />
                  <FormControlLabel
                    sx={styles.field}
                    value
                    control={
                      <Radio color="primary" sx={styles.radio} />
                    }
                    labelPlacement="top"
                    label="INDIVIDUAL"
                  />
                </CardBase>
              </Grid>
            </Grid>
          </RadioGroup>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SponsorshipType;
